document.addEventListener('click', function(event) {
  const button = event.target.closest('.cart-upsell-card__submit-btn');
  if (!button) return;

  event.preventDefault();

  const form = button.closest('.cart-upsell__form-element');
  if (!form) return;

  button.setAttribute('aria-disabled', 'true');
  button.classList.add('loading');
  
  const textSpan = button.querySelector('span:first-child');
  const spinner = button.querySelector('.loading__spinner');
  if (textSpan) textSpan.classList.add('hidden');
  if (spinner) spinner.classList.remove('hidden');

  const formData = new FormData(form);
  
  // Detect if current path is the Cart page
  const isCartPage = window.location.pathname === (window.routes?.cart_url || '/cart') || window.location.pathname.endsWith('/cart');
  
  // Bypass cart drawer if on the Cart page
  const cartDrawer = !isCartPage ? document.querySelector('cart-drawer') : null;
  const cartItems = document.querySelector('cart-items');
  const cartAddUrl = window.routes?.cart_add_url || '/cart/add';

  if (cartDrawer) {
    formData.append('sections', 'cart-drawer,cart-icon-bubble');
    formData.append('sections_url', window.location.pathname);
  } else if (cartItems) {
    const sectionIds = cartItems.getSectionsToRender().map(section => section.section);
    formData.append('sections', sectionIds.join(','));
    formData.append('sections_url', window.location.pathname);
  }

  fetch(`${cartAddUrl}.js`, {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  .then(response => response.json())
  .then(response => {
    if (response.status === 422 || response.status === 400) {
      console.error('Cart Error:', response.description || response.message);
      alert(response.description || response.message);
      return;
    }

    // Refresh display dynamically without page reload
    if (cartDrawer) {
      cartDrawer.renderContents(response);
    } else if (cartItems) {
      cartItems.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);
        if (elementToReplace && response.sections && response.sections[section.section]) {
          elementToReplace.innerHTML = new DOMParser()
            .parseFromString(response.sections[section.section], 'text/html')
            .querySelector(section.selector).innerHTML;
        }
      });
    } else {
      window.location.reload();
    }
  })
  .catch(error => {
    console.error('Add to cart error:', error);
  })
  .finally(() => {
    if (button) {
      button.classList.remove('loading');
      button.removeAttribute('aria-disabled');
      const textSpan = button.querySelector('span:first-child');
      const spinner = button.querySelector('.loading__spinner');
      if (textSpan) textSpan.classList.remove('hidden');
      if (spinner) spinner.classList.add('hidden');
    }
  });
});

// Scroll event listener to manage mobile sticky behavior for Order Summary box
document.addEventListener('DOMContentLoaded', () => {
  const initMobileStickySummary = () => {
    const summaryBox = document.querySelector('.cart-summary-box');
    const cartGrid = document.querySelector('.cart-grid');
    
    if (!summaryBox || !cartGrid) return;
    
    const handleScroll = () => {
      if (window.innerWidth >= 990) {
        summaryBox.classList.remove('is-mobile-sticky');
        return;
      }
      
      const gridRect = cartGrid.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      
      // If the bottom of the items/upsells container is above or at the viewport bottom,
      // release sticky docking so the summary box sits inline naturally above the footer.
      if (gridRect.bottom <= viewportHeight) {
        summaryBox.classList.remove('is-mobile-sticky');
      } else {
        summaryBox.classList.add('is-mobile-sticky');
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll, { passive: true });
    handleScroll(); // Run immediately on load
  };

  initMobileStickySummary();
  
  // Re-run listener initialization on Shopify section rendering API refreshes
  document.addEventListener('shopify:section:load', initMobileStickySummary);
});
